import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment,useRef,} from 'react';
import {Typography,Button,Box,Grid, TextField,Paper, MenuItem} from "@mui/material";
import apiRequest from '../../../functions/api';
import { useMessage } from '../../../context/message-context';
import DynamicTable from "../components/DynamicTableComponent";
import ResponsiveDialog from '../components/ResponsiveDialog'
import { FullPageSpinner } from "../../lib";
import MessageBox from "../components/MessageBox";
import Autocomplete from '@mui/material/Autocomplete';
function AblagenamenAuswahl(props) {
  const { t } = useTranslation();
const { accessToken,  client, programm,setAblageKey,setHDOKOpen,hdokopen,archiv,starthdok} = props;
const [options,setOptions] = useState([]);
const fehlertext=useRef("");
const [spin,setSpin]=useState(false)
const {showErrorMessage,showSuccessMessage} = useMessage();
const [messageopen,setMessageOpen]=useState("")
const [aenderung,setAenderung]=useState("");
const [hdoks,setHDOKs]=useState([]);
const [hdokwahl,setHDOKWahl]=useState("");
const [mddfwahl,setMDDFWahl]=useState("");
const [mddfs,setMDDFs]=useState([]);
const [hdokdaten,setHDOKDaten]=useState([]);
const [mddfdaten,setMDDFDaten]=useState([]);
const [erstellen,setErstellen]=useState(false);
const [neuname,setNEUName]=useState("");
useEffect(() => {
  if (hdokopen) {
    setHDOKWahl(starthdok);
    setMDDFWahl("");
    lade_ablagenamen();
    setErstellen(false);
  }
  // eslint-disable-next-line
}, [hdokopen])
const errorcB = () => {
  setSpin(false);
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const initCB = (response) => {
  setSpin(false);
  if (response.status === 200) {
     if (response.data.mddfs) {
      setMDDFs(response.data.mddfs)
    } else {
      setMDDFs([])
    } 
    if (response.data.hdoks) {
      setHDOKs(response.data.hdoks)
    } else {
      setHDOKs([])
    } 
    if (response.data.hdokdaten) {
      setHDOKDaten(response.data.hdokdaten)
    }
    if (response.data.mddfdaten) {
      setMDDFDaten(response.data.mddfdaten)
    }
  } else {
      if (response) {
       fehlertext.current=response.data?.message;
    //    showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
  }      
}
const lade_ablagenamen = () => {
  setSpin(true);
  const payload={
    "mandant": client,
    "program": programm,
    "statement": "HDOK_LADEN",
    "archiv":archiv,
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'interview', payload, headers, initCB, errorcB);
}
const zeichne_speichern = () => {
  return(
    <Fragment>
          <Grid item xs={6}>
            <Box p={1}>
              <Button variant="outlined" fullWidth color="primary" fullWidth onClick={()=> setHDOKOpen(false)} >{t(" Abbruch ")}</Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
           <Box p={1}>
              <Button variant="contained" fullWidth color="primary" fullWidth onClick={()=> buttonClick("SPEICHERN","")} disabled={(!erstellen&&!hdokwahl)}  > {erstellen? "Anlegen":"Auswählen"} </Button>
            </Box>
          </Grid>
    </Fragment>
  )
}
const anlageCB = (response) => {
   setSpin(false);
   if (response.status === 200) {
      setHDOKOpen(false);
      if (response.data.hdokkey) {
          setAblageKey(response.data.hdokkey)
      } 
   } else {
       if (response) {
        fehlertext.current=response.data?.message;
        setMessageOpen(true)
     //    showErrorMessage(response.data.message);
       } else {
         showErrorMessage(t("Keine Internetverbindung"));
       }
   }      
 }
const anlegen = () => {
  setSpin(true);
  const payload={
    "mandant": client,
    "program": programm,
    "statement": "HDOK_SPEICHERN",
    "mddf":mddfwahl,
    "name":neuname
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'interview', payload, headers, anlageCB, errorcB);
}
const buttonClick = (spaltenkey) => {
   switch (spaltenkey) {
      case "SPEICHERN":
        if (erstellen) {anlegen();} else {setAblageKey(hdokwahl);setHDOKOpen(false);}
       break;
      default:
       break;
   }
}
const handleResponse = (result) => {
  setMessageOpen(false);
  fehlertext.current=""
}
const zeichne_info = () => { 
  if (!erstellen) {
  return (
    <Fragment>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Name"}
            value={hdokdaten?.["X"+hdokwahl]?.name ? hdokdaten?.["X"+hdokwahl]?.name : ""}
            disabled={!erstellen}
            key={'HDOKNAME'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            error={erstellen &&!neuname}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Dokumentendefinition"}
            value={hdokdaten?.["X"+hdokwahl]?.mddf? hdokdaten?.["X"+hdokwahl]?.mddf : ""}
            disabled={true}
            key={'DOKDEF'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Ablageort"}
            value={hdokdaten?.["X"+hdokwahl]?.ablort? hdokdaten?.["X"+hdokwahl]?.ablort : ""}
            disabled={true}
            key={'ABLORT'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Aufbewahrungsfrist"}
            value={hdokdaten?.["X"+hdokwahl]?.frist ? hdokdaten?.["X"+hdokwahl]?.frist: ""}
            disabled={true}
            key={'AUFBEWAHR'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Grid>      
    </Fragment>
  )
  } else {
    return (
    <Fragment>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Bezeichnung des neuen Ablagenamens"}
            value={neuname? neuname : ""}
            disabled={!erstellen}
            key={'HDOKNAME'}
            fullWidth
            onChange={(event) => {
              setNEUName(event.target.value);
            }
            }
            InputLabelProps={{
              shrink: true,
            }}
            error={!neuname}
            helperText={!neuname ? "Bitte geben Sie eine Bezeichnung für den neuen Ablagenamen ein" : ""}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
       <Box p={1} pt={2}>
        <Autocomplete
          noOptionsText={t("Es wurde keine Dokumentendefinition gefunden. Bitte Suche anpassen")}
          onChange={(event, newValue) => {
            setMDDFWahl(newValue?.key);
            setHDOKWahl("");
          }
          }
          options={mddfs}            
          getOptionLabel={(option) => option.zusatz ? option.bez + " " + option.zusatz : option.bez}
          value={mddfwahl==="" ? "" : mddfs.find((antwort) => antwort.key===mddfwahl) } 
          renderInput={(params) => 
            <TextField 
              {...params} 
              label={"Dokumentendefinition des neuen Ablagenamens"} 
              variant="outlined" 
              InputLabelProps={{
                shrink: true,
              }}
              
              helperText={!mddfwahl ? "Wählen Sie hier eine Dokumentendefinition aus":""}
              error={!mddfwahl}  
            />
          }
        /> 
       </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Ablageort"}
            value={mddfdaten?.["X"+mddfwahl]?.ablort? mddfdaten?.["X"+mddfwahl]?.ablort : ""}
            disabled={true}
            key={'ABLORT'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            variant="outlined"
            label={"Aufbewahrungsfrist"}
            value={mddfdaten?.["X"+mddfwahl]?.frist ? mddfdaten?.["X"+mddfwahl]?.frist: ""}
            disabled={true}
            key={'AUFBEWAHR'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Grid>      
    </Fragment>
    )
  }
}
const zeichne_auswahl = () => {
  return (
    <Fragment>
      <Grid item xs={12}>
        <Box p={1} pt={2}>
        <Autocomplete
          noOptionsText={t("Es wurde kein Ablagenamen gefunden. Bitte Suche anpassen oder einen neuen Ablagenamen erstellen")}
          onChange={(event, newValue) => {
            setHDOKWahl(newValue?.key);
            setErstellen(false);
            setMDDFWahl("");
          }
          }
          options={hdoks}            
          getOptionLabel={(option) => option.zusatz ? option.bez + " " + option.zusatz : option.bez}
          value={hdokwahl==="" ? "" : hdoks.find((antwort) => antwort.key===hdokwahl) } 
          renderInput={(params) => 
            <TextField 
              {...params} 
              label={t("Ablagename")}
              variant="outlined" 
              InputLabelProps={{
                shrink: true,
              }}
              
              helperText={<Button color="primary" variant="text" onClick={()=> {setHDOKWahl("");setErstellen(true);setNEUName("");} } >{"neuen Ablagenamen erstellen"}</Button>}      
            />
          }
        /> 
        </Box> 
      </Grid>
   </Fragment>
  )
}
return (
  <ResponsiveDialog 
    title={t("Auswahl Ablagenamen")}
    open={hdokopen} 
    setOpen={(o) => {setHDOKOpen(false)}}
  >
    <Grid container spacing={2} justifyContent="center">          
    <Grid item xs={12}>
    <Grid container justifyContent="center">  
      { zeichne_auswahl()}
      { zeichne_info()}
      { zeichne_speichern()}
    </Grid> 
    </Grid>
    </Grid>
               
    { spin &&
      <FullPageSpinner/>
    }
  
    <MessageBox 
      open={messageopen}
      handleResponse={handleResponse}
      text={fehlertext.current}
      title={t("Hinweis")}
      onClose={() => handleResponse(false)}
    />
  </ResponsiveDialog>
)
}
export default AblagenamenAuswahl;
